import React from "react";
import useEscapeKey from "../../hooks/use-escape-key";

export const ToastContext = React.createContext();

function ToastProvider({ children }) {
  const [toastList, setToastList] = React.useState([]);

  function handleDismiss(id) {
    const newToast = toastList.filter((toast) => {
      return toast.id !== id;
    });
    setToastList(newToast);
  }

  useEscapeKey(() => {
    setToastList([]);
  });

  function addToast(message, variant) {
    setToastList([...toastList, { id: Math.random(), variant, message }]);
  }

  return (
    <ToastContext.Provider
      value={{
        toastList,
        addToast,
        handleDismiss,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
}

export default ToastProvider;
